import { BaseSyntheticEvent, FC, useCallback, useState, useMemo } from "react";
import { TdInput } from "../components/Inputs/TdInput";
import { DefaultButton, TBody } from "shared/pages/teams/styles";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { FlexBox, INPUT_TYPES } from "@brg/ui";
import { EditorWrapper, SectionTitle, Table } from "../styles";
import SortableList, { SortableItem } from "react-easy-sort";
import { useTranslation } from "react-i18next";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import setTextByLang from "shared/helpers/setTextByLang";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { CompetitionInputNames } from "shared/modals/competitionLegalsModal/types";
import { FormFieldType } from "../constants";
import { generateUniqueString } from "shared/utils/generateUniqueString";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";

const FieldsEditor: FC = () => {
  const { t } = useTranslation();
  const { fields, variantOption: { visible: displayModal, optionIndex } } = useSelector(ApplicationEditorSelector);
  const dispatch = useDispatch();
  const action = ApplicationEditorActions;

  const onAddField = () => {
    dispatch(action.addField({
      type: FormFieldType.Text,
      header: createDefaultLangObject(' '),
      placeholder: createDefaultLangObject(' '),
      isRequired: false,
      inlineVariants: [],
      fieldIdInCrm: 0,
      isTagInCrm: false,
      isDisabled: false
    }));
  }

  const onDeleteField = (index: number) => {
    dispatch(action.removeField(index));
  };

  const onSortEnd = (oldIndex: number, newIndex: number) => {
    const newData = arrayMoveImmutable(fields, oldIndex, newIndex);
    dispatch(action.setFields(newData));
  };

  const onSwitchChange = useCallback((index: number, value: number | boolean) => {
    const newData = fields.map((field, i) => (i === index ? { ...field, isDisabled: value === 0 } : field));
    dispatch(action.setFields(newData));
  }, [fields, dispatch]);

  const onToggleVariantModalClick = (index: number) => {
    // const data = fields?.find(
    //   (field, i) => i === index)?.inlineVariants || [];
    dispatch(action.setVariantOption({
      visible: true,
      optionIndex: index,
    }));
  };

  const onRequiredChange = (index: number, value: boolean) => {
    const newData = fields.map((field, i) => i === index ? { ...field, isRequired: value } : field);
    dispatch(action.setFields(newData));
  };

  const onUpdateField = (index: number, ev: BaseSyntheticEvent, lang?: string) => {
    const key = ev?.target?.name;
    const value = ev?.target?.value;
    const prevValue = fields.find(
      (field, i) => i === index)?.[key as keyof typeof fields[0]] as LangObjectArray;
    if (!lang) {
      const newData = fields.map((field, i) => i === index ? { ...field, [key as keyof typeof fields[0]]: value } : field);
      dispatch(action.setFields(newData));
      return
    }
    const newData = fields.map((field, i) => i === index ? { ...field, [key]: setTextByLang(prevValue, lang, value) } : field);
    dispatch(action.setFields(newData));
  };

  return (
    <EditorWrapper gy={24}>
      <SectionTitle>{t('applicationEditor.sections.fields.field_title')}</SectionTitle>
      {fields?.length > 0 && (
        <Table> 
          <thead>
            <tr>
              <th ></th>
              <th>{t('teams.adminPage.fields.form_field_name')}</th>
              <th>{t('teams.adminPage.fields.form_field_type')}</th>
              <th style={{textAlign: 'center'}}>{t('teams.adminPage.fields.form_field_required')}</th>
              <th style={{textAlign: 'center' }}></th>
              <th style={{textAlign: 'center'}}></th>
            </tr>
          </thead>
          <SortableList
            as={'tbody'}
            onSortEnd={onSortEnd}
            lockAxis="y"
            draggedItemClassName="application-editor-sortable-dragged"
          >
          {fields?.map((field, index) => {
            return (
              <SortableItem
                key={`fields-editor-sortable-${index}`}
              >
                <TdInput
                  {...field}
                  index={index}
                  onChange={onUpdateField}
                  onSwitchChange={onSwitchChange}
                  onDeleteField={onDeleteField}
                  onRequiredChange={onRequiredChange}
                  onToggleModalClick={onToggleVariantModalClick}
                />
              </SortableItem>
        
            )                                                              
          })}
          </SortableList>
        </Table>
      )}

      <ProjectAddButton reverse onClick={onAddField} text={t('teams.adminPage.fields.form_add_field')} />
    </EditorWrapper>
  );
};

export default FieldsEditor;import { BaseSyntheticEvent, FC, useCallback, useState, useMemo } from "react";
import { TdInput } from "../components/Inputs/TdInput";
import { DefaultButton, TBody } from "shared/pages/teams/styles";
import { ProjectAddButton } from "shared/pages/projectEdit/ProjectAddButton";
import { FlexBox, INPUT_TYPES } from "@brg/ui";
import { EditorWrapper, SectionTitle, Table } from "../styles";
import SortableList, { SortableItem } from "react-easy-sort";
import { useTranslation } from "react-i18next";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults";
import setTextByLang from "shared/helpers/setTextByLang";
import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { CompetitionInputNames } from "shared/modals/competitionLegalsModal/types";
import { FormFieldType } from "../constants";
import { generateUniqueString } from "shared/utils/generateUniqueString";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationEditorActions, ApplicationEditorSelector } from "shared/reducers/ApplicationEditorSlice";

const FieldsEditor: FC = () => {
  const { t } = useTranslation();
  const { fields, variantOption: { visible: displayModal, optionIndex } } = useSelector(ApplicationEditorSelector);
  const dispatch = useDispatch();
  const action = ApplicationEditorActions;

  const onAddField = () => {
    dispatch(action.addField({
      type: FormFieldType.Text,
      header: createDefaultLangObject(' '),
      placeholder: createDefaultLangObject(' '),
      isRequired: false,
      inlineVariants: [],
      fieldIdInCrm: 0,
      isTagInCrm: false,
      isDisabled: false
    }));
  }

  const onDeleteField = (index: number) => {
    dispatch(action.removeField(index));
  };

  const onSortEnd = (oldIndex: number, newIndex: number) => {
    const newData = arrayMoveImmutable(fields, oldIndex, newIndex);
    dispatch(action.setFields(newData));
  };

  const onSwitchChange = useCallback((index: number, value: number | boolean) => {
    const newData = fields.map((field, i) => (i === index ? { ...field, isDisabled: value === 0 } : field));
    dispatch(action.setFields(newData));
  }, [fields, dispatch]);

  const onToggleVariantModalClick = (index: number) => {
    // const data = fields?.find(
    //   (field, i) => i === index)?.inlineVariants || [];
    dispatch(action.setVariantOption({
      visible: true,
      optionIndex: index,
    }));
  };

  const onRequiredChange = (index: number, value: boolean) => {
    const newData = fields.map((field, i) => i === index ? { ...field, isRequired: value } : field);
    dispatch(action.setFields(newData));
  };

  const onUpdateField = (index: number, ev: BaseSyntheticEvent, lang?: string) => {
    const key = ev?.target?.name;
    const value = ev?.target?.value;
    const prevValue = fields.find(
      (field, i) => i === index)?.[key as keyof typeof fields[0]] as LangObjectArray;
    if (!lang) {
      const newData = fields.map((field, i) => i === index ? { ...field, [key as keyof typeof fields[0]]: value } : field);
      dispatch(action.setFields(newData));
      return
    }
    const newData = fields.map((field, i) => i === index ? { ...field, [key]: setTextByLang(prevValue, lang, value) } : field);
    dispatch(action.setFields(newData));
  };

  return (
    <EditorWrapper gy={24}>
      <SectionTitle>{t('applicationEditor.sections.fields.field_title')}</SectionTitle>
      {fields?.length > 0 && (
        <Table> 
          <thead>
            <tr>
              <th ></th>
              <th>{t('teams.adminPage.fields.form_field_name')}</th>
              <th>{t('teams.adminPage.fields.form_field_type')}</th>
              <th style={{textAlign: 'center'}}>{t('teams.adminPage.fields.form_field_required')}</th>
              <th style={{textAlign: 'center' }}></th>
              <th style={{textAlign: 'center'}}></th>
            </tr>
          </thead>
          <SortableList
            as={'tbody'}
            onSortEnd={onSortEnd}
            lockAxis="y"
            draggedItemClassName="application-editor-sortable-dragged"
          >
          {fields?.map((field, index) => {
            return (
              <SortableItem
                key={`fields-editor-sortable-${index}`}
              >
                <TdInput
                  {...field}
                  index={index}
                  onChange={onUpdateField}
                  onSwitchChange={onSwitchChange}
                  onDeleteField={onDeleteField}
                  onRequiredChange={onRequiredChange}
                  onToggleModalClick={onToggleVariantModalClick}
                />
              </SortableItem>
        
            )                                                              
          })}
          </SortableList>
        </Table>
      )}

      <ProjectAddButton reverse onClick={onAddField} text={t('teams.adminPage.fields.form_add_field')} />
    </EditorWrapper>
  );
};

export default FieldsEditor;